import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  model,
  output,
} from '@angular/core';

import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { TranslateModule } from '@ngx-translate/core';

import {
  SegmentedToggleComponent,
  SegmentedToggleOption,
} from '@shared/segmented-toggle/segmented-toggle.component';
import {
  CONTENT_MODE_ORDER,
  DocumentMode,
} from '@core/constants/guided-course-creation.constants';

@Component({
  selector: 'app-ai-settings-panel',
  templateUrl: './ai-settings-panel.component.html',
  styleUrls: ['./ai-settings-panel.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    MatButtonModule,
    MatIconModule,
    MatMenuModule,
    MatSlideToggleModule,
    TranslateModule,
    SegmentedToggleComponent,
  ],
})
export class AiSettingsPanelComponent {
  readonly hasDocument = input(false);
  readonly contentMode = input.required<DocumentMode>();

  readonly contentGenerationEnabled = model(true);
  readonly imageGenerationEnabled = model(false);

  readonly modeSelected = output<DocumentMode>();

  readonly modeOptions: readonly SegmentedToggleOption<DocumentMode>[] =
    CONTENT_MODE_ORDER.map(mode => ({
      value: mode,
      labelKey: `guidedCourseCreation.contentMode.${mode}`,
    }));

  readonly showContentMode = computed(
    () => this.contentGenerationEnabled() && this.hasDocument(),
  );

  readonly modeDescriptionKey = computed(
    () => `guidedCourseCreation.contentMode.description.${this.contentMode()}`,
  );
}
